import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import HeroSearchForm from './HeroSearchForm';
import PropertyBookModal from './PropertyBookModal';
import PropertyData from "./property-list.json";
import Icon from '@mdi/react';
import { mdiMapMarkerRadiusOutline, mdiBedKingOutline, mdiShower, mdiShieldLockOutline, mdiWifi, mdiCarSide, mdiHeartOutline, mdiHeart, mdiPool, mdiDumbbell, mdiFlower, mdiMovieOpenOutline, mdiGarage, mdiWashingMachine } from '@mdi/js';
import { Link } from 'react-router-dom';
// img
import heroBottomImg from "../../images/hero-bg-01.png";
import Footer from '../Layout/Footer';

export default function PropertyList() {
  const [PropertyDataList] = useState(PropertyData);

  // Popup
  const [showProperty, setShowProperty] = useState(false);
  const handleCloseProperty = () => setShowProperty(false);
  const handleShowProperty = () => setShowProperty(true);

  // icon fill
  const [likedDeals, setLikedDeals] = useState(
    PropertyDataList.PopularDeals.map(() => false)
  );
  const handleIconClick = (index) => {
    const updatedLikes = likedDeals.map((liked, i) => (i === index ? !liked : liked));
    setLikedDeals(updatedLikes);
  };

  // property icon 
  const getIconPath = (iconName) => {
    switch (iconName) {
      case 'mdiWashingMachine':
        return mdiWashingMachine;
      case 'mdiGarage':
        return mdiGarage;
      case 'mdiMovieOpenOutline':
        return mdiMovieOpenOutline;
      case 'mdiFlower':
        return mdiFlower;
      case 'mdiDumbbell':
        return mdiDumbbell;
      case 'mdiPool':
        return mdiPool;
      case 'mdiBedKingOutline':
        return mdiBedKingOutline;
      case 'mdiShower':
        return mdiShower;
      case 'mdiShieldLockOutline':
        return mdiShieldLockOutline;
      case 'mdiWifi':
        return mdiWifi;
      case 'mdiCarSide':
        return mdiCarSide;
      default:
        return mdiShower;
    }
  };

  return (
    <>
      {/* hero section start */}
      <section className='property-list-hero'>
        <Container >
          <Row className='justify-content-center mb-4'>
            <Col lg={10} xl={7} className='text-center'>
              <h1 className='fw-bold display-5 text-shadow'>Explore Premium Properties Tailored for You</h1>
              <div className='d-flex align-items-center w-50 mx-auto opacity-50'>
                <i className="bi bi-star-fill fs-12 text-muted"></i>
                <div className='d-flex w-100 mx-3'>
                  <hr className="border border-secondary w-50 border-1" />
                  <hr className="border border-secondary w-100 border-1 mx-2" />
                  <hr className="border border-secondary w-50 border-1" />
                </div>
                <i className="bi bi-star-fill fs-12 text-muted"></i>
              </div>
            </Col>
          </Row>
        </Container>
        <div className='hero-bottom-img'>
          <Container>
            <Row className='justify-content-center'>
              <Col lg={12}>
                <img src={heroBottomImg} alt="" className='img-fluid opacity-75' />
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/* hero section end */}

      <section className='section'>
        <Container>
          <Row className='justify-content-center'>
            <Col lg={12}>
              <div className='bg-light rounded-3 p-3 mb-5'>
                <HeroSearchForm />
              </div>
            </Col>
            {PropertyDataList.PopularDeals.map((data, i) =>
              <Col md={6} xl={4} xxl={6} key={i} className='mb-4'>
                <Card className='proporty-deals-card border border-light overflow-hidden mb-0 h-100 rounded-3'>
                  <Card.Body className='p-3'>
                    <Row className='align-items-center'>
                      <Col xxl={6}>
                        <div className='proporty-deals-img'>
                          <span className={`sale-badge ${data.badgeDisplay}`}>For Sale</span>
                          <img src={require(`../../images/property-img/${data.propertyImg}`)} alt='' className='img-fluid proporty-img rounded-3' />
                        </div>
                      </Col>
                      <Col xxl={6}>
                        <div className="d-flex align-items-center justify-content-between mb-2 mt-4 mt-xxl-0">
                          <h4 className='text-primary fw-semibold mb-0'>{data.propertyPrice}/ <span className='fs-14'>Night</span></h4>
                          <Link to='' className='text-danger float-end heart-icon' onClick={() => handleIconClick(i)}>
                            <Icon
                              path={likedDeals[i] ? mdiHeart : mdiHeartOutline}
                              className='icon-size-20 text-danger'
                            />
                          </Link>
                        </div>
                        <Card.Title className=''>{data.propertyTitle}</Card.Title>
                        <div className='d-flex align-items-center text-muted fs-15'>
                          <Icon path={mdiMapMarkerRadiusOutline} className='icon-size-18 me-2' />{data.homeLocation}
                        </div>
                        <div className='d-flex flex-wrap align-items-center gap-2 mt-2 mb-3'>
                          {data.propertyFeatures.map((feature, j) => (
                            <Badge bg="light" className='text-dark fs-13 d-flex align-items-center' key={j}>
                              <Icon path={getIconPath(feature.icon)} className='icon-size-16 me-2' />
                              {feature.value}
                            </Badge>
                          ))}
                        </div>
                        <Button variant="soft-primary" size='sm' onClick={handleShowProperty}>View More</Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>


              // <Col md={6} lg={4} xxl={3} key={i}>
              //   <Card className='proporty-deals-card overflow-hidden'>
              //     <div className='proporty-deals-img'>
              //       <div className='proporty-deals-img-content'>
              //         <Badge bg="white" text="dark" className={`badge-lg ${data.badgeDisplay}`}>For Sale</Badge>
              //         <Link to='' className='avatar avatar-xs rounded-pill bg-soft-dark text-white float-end heart-icon'>
              //           <Icon path={mdiHeart} className='icon-size' />
              //         </Link>
              //       </div>
              //       <img src={require(`../../images/property-img/${data.propertyImg}`)} alt='' className='img-fluid proporty-img' />
              //     </div>
              //     <Card.Body className='pt-3'>
              //       <Card.Title className='fw-semibold pb-1'>{data.propertyTitle}</Card.Title>
              //       <div className='d-flex align-items-center text-muted fs-16'>
              //         <Icon path={mdiMapMarkerRadiusOutline} className='icon-size-18 me-2' />{data.homeLocation}
              //       </div>
              //       <ul className='list-inline mt-2'>
              //         <li className='list-inline-item'>
              //           <div className='d-flex align-items-center text-muted fs-16'>
              //             <Icon path={mdiBedKingOutline} className='icon-size-18 me-2' />{data.bedroomNumber} Bedroom
              //           </div>
              //         </li>
              //         <li className='list-inline-item'><i className="bi bi-dot text-muted px-1 opacity-50"></i></li>
              //         <li className='list-inline-item'>
              //           <div className='d-flex align-items-center text-muted fs-16'>
              //             <Icon path={mdiShower} className='icon-size-18 me-2' />{data.bathtoomNumber} Bathroom
              //           </div>
              //         </li>
              //       </ul>
              //       <hr />
              //       <div className='d-flex justify-content-between align-items-center'>
              //         <h5 className='text-primary mb-0 fw-bold'>{data.propertyPrice}/ <span className='fs-14 fw-medium'>Night</span></h5>
              //         <Button variant="outline-secondary" size='sm' onClick={handleShowProperty}>View More</Button>
              //       </div>
              //     </Card.Body>
              //   </Card>
              // </Col>
            )}
          </Row>
          <Row>
            <Col lg={12} className='text-center'>
              <div className="spinner-border text-primary mt-5" role="status"></div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Footer */}
      <Footer />

      <PropertyBookModal
        showProperty={showProperty}
        handleCloseProperty={handleCloseProperty}
      />
    </>
  )
}
